import Emittery from 'emittery'
import moment from 'moment'

class Base {
  constructor () {
    const emitter = new Emittery()
    const emitterAPI = ['on', 'off', 'once', 'onAny', 'offAny', 'emit', 'emitSerial']
    emitterAPI.forEach((api) => {
      Object.defineProperty(this, api, {
        enumerable: false,
        value: emitter[api].bind(emitter)
      })
    })
  }

  __triggerEvent (type, data = {}) {
    if (!data.eventTimestamp) {
      data.eventTimestamp = moment().utc().valueOf()
    }
    // console.log(`[${this.constructor.name}]: Emitting evt=${type} data=${JSON.stringify(data)}`)
    return this.emit(type, data)
  }
}

function createEvent (event, data = {}) {
  // If data has eventTimestamp, remove it
  const ret = {
    event,
    eventTimestamp: data?.eventTimestamp || moment().utc().valueOf()
  }
  if (data) {
    ret.data = data
    delete data.eventTimestamp
  }
  return ret
}

export {
  Base,
  createEvent,
  moment
}
